import appCaptains from "../../views/appFleet/captains.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "captains";
  const params = [
    "page",
    "limit",
    "city",
    "company",
    "rating",
    "active",
    "sort",
  ];

  $stateProvider.state("captains", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCaptains,
      },
    },
    reloadOnSearch: false,
    data: { title: "Captains" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captains/captains.urls.js